/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { slugConverter } from '../../../../utils/converter'
import OutsideClickHandler from 'react-outside-click-handler'
import styles from './cityOptionsModal.module.scss'

export default function CityOptionsModal({
  currentState,
  citiesByState,
  query,
  setShowOptions,
}) {
  const data = citiesByState
  const states =
    data[1].states.filter(
      (elem) => elem.state_code === currentState.toUpperCase(),
    ).length > 0
      ? data[1].states.filter(
          (elem) => elem.state_code === currentState.toUpperCase(),
        )
      : data[0].states.filter(
          (elem) => elem.state_code === currentState.toUpperCase(),
        )

  const [cities, setCities] = useState(states[0]?.cities)

  useEffect(() => {
    if (query.length === 0) {
      setCities(states[0]?.cities)
    }
    if (query.length > 0) {
      setCities(
        states[0].cities.filter((city) =>
          city.name.toLowerCase().includes(query),
        ),
      )
    }
  }, [query])

  return (
    <div className={styles.options}>
      <OutsideClickHandler
        onOutsideClick={() => {
          setShowOptions(false)
        }}
      >
        <div className={styles.arrow} />
        <div className={styles.header}>
          <div className={styles.container}>
            {cities.length > 0 ? (
              cities.map((elem, index) => {
                return (
                  <div key={index}>
                    <Link
                      href={`/find-a-vet/${currentState.toLowerCase()}/${slugConverter(
                        elem.name,
                      ).toLowerCase()}`}
                    >
                      {' '}
                      {elem.name},{currentState.toUpperCase()}
                    </Link>
                  </div>
                )
              })
            ) : (
              <div className={styles.noMatching}>
                <img src="/search/error.svg" alt="error" />

                <p>No found</p>
              </div>
            )}
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  )
}
